import type { Quiz } from "./_schema";
import { igniteQuiz } from "./ignite";

export const quizRegistry: Record<string, Quiz> = {
  [igniteQuiz.slug]: igniteQuiz,
};
